import React from 'react';
import BackButton from '../components/BackButton';
import Footer from '../components/Footer';
import '../App.scss';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <BackButton />
      
      <div className="page-header">
        <h1>About Math Explorer</h1>
        <p>Making Math Learning Fun and Accessible for Kids</p>
        <img 
          src="/images/kids_learning_math.webp" 
          alt="Kids learning math together" 
          className="about-hero-image"
        />
      </div>

      <div className="page-content">
        <div className="about-section">
          <h2>Our Mission</h2>
          <p>
            Math Explorer was created to help children develop a strong foundation in mathematics through interactive and engaging tools. 
            We believe that understanding basic mathematical principles should be fun, intuitive, and accessible to all children.
          </p>
        </div>

        <div className="about-section">
          <h2>Our Tools</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>Multiplication Tables</h3>
              <p>
                A visual and interactive way to learn multiplication tables. 
                Children can see how multiplication works through visual representations of groups and items.
              </p>
            </div>
            
            <div className="feature-card">
              <h3>Length Units Game</h3>
              <p>
                An engaging game that helps children understand different units of length and their relationships. 
                Through real-world examples, kids learn to estimate and compare measurements.
              </p>
            </div>
            
            <div className="feature-card">
              <h3>Math Operations</h3>
              <p>
                Interactive exercises that make learning basic operations (addition, subtraction, multiplication, division) 
                more engaging and less intimidating.
              </p>
            </div>
            
            <div className="feature-card">
              <h3>Basic Operations Tutorials</h3>
              <p>
                Step-by-step guides that break down complex operations into simple, understandable concepts. 
                Perfect for building confidence in mathematical problem-solving.
              </p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h2>Why Math Explorer?</h2>
          <ul className="benefits-list">
            <li>Interactive learning through games and visual aids</li>
            <li>Clear explanations of mathematical concepts</li>
            <li>Progress tracking and immediate feedback</li>
            <li>Safe, ad-free environment for learning</li>
            <li>Accessible on various devices</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Our Commitment</h2>
          <p>
            We are committed to creating educational tools that make learning math enjoyable and effective. 
            Our team continuously works to improve the app based on feedback from educators, parents, and most importantly, 
            the children who use it.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About; 